var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { QueryBuilder } from './drivers/default/builders/queryBuilder';
export class Model {
    constructor(attributes, relations) {
        this.$keyName = 'id';
        this.$init();
        if (attributes) {
            this.$setAttributes(attributes);
        }
        if (relations) {
            this.$setRelations(this.$relations);
        }
    }
    static $query() {
        return new QueryBuilder(this);
    }
    $query() {
        return new QueryBuilder(this.constructor);
    }
    $save(attributes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (attributes) {
                this.$setAttributes(attributes);
            }
            yield this.$query().update(this.$getKey(), (attributes || this.$attributes));
            return this;
        });
    }
    $destroy(force = false) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.$query().destroy(this.$getKey(), force);
            return this;
        });
    }
    $getKeyName() {
        return this.$keyName;
    }
    $setKeyName(keyName) {
        this.$keyName = keyName;
        return this;
    }
    $getKey() {
        return this.$attributes[this.$getKeyName()];
    }
    $setKey(key) {
        this.$attributes[this.$getKeyName()] = key;
        return this;
    }
    $setAttributes(attributes) {
        for (const attribute in attributes) {
            this.$attributes[attribute] = attributes[attribute];
        }
        return this;
    }
    $setRelations(relations) {
        for (const relation in relations) {
            this.$relations[relation] = relations[relation];
        }
        return this;
    }
    $is(model) {
        return this.$getKey() === model.$getKey();
    }
    $init() {
        if (!this.$attributes) {
            this.$attributes = {};
        }
        if (!this.$relations) {
            this.$relations = {};
        }
    }
}
//# sourceMappingURL=model.js.map